import { Grid } from "@material-ui/core"

import MainCard from "../../../shared/components/cards/MainCard"
import { HelpCenterFaq } from "../components/HelpCenterFaq"

export const HelpCenterFaqScreen = () => {
   return <Grid component={MainCard} sx={{ padding: 2 }}>
      <HelpCenterFaq />
   </Grid>
}